export const initialForm = {
  name: '',
  extId: '',
  isActive: true,
  contentType: undefined,
  sectionType: 'viewscreens',
  selectedViewscreens: [],
  informerTag: null,
  sections: [],
  segments: [],
  apps: [],
}

export const defaultInformerImg = {
  id: null,
  preview: '',
  file: null,
  loading: false,
}

export const defaultInformerInfo = {
  title: '',
}

export const defaultDialogueButton = {
  buttonName: '',
  buttonColor: '',
  fontColor: '',
  linkType: 'custom',
  linkName: '',
  sportId: '',
  link: [],
  id: '',
}

export const defaultInformerRedirect = {
  isRedirectAvailable: false,
  redirectType: 'link',
  linkRedirect: {
    linkType: 'custom',
    linkName: '',
    sportId: '',
    link: [],
    id: '',
  },
  dialogueRedirect: {
    img: {
      ...defaultInformerImg,
    },
    title: '',
    text: '',
    isDialogueButtonAvailable: false,
    dialogueButton: {
      ...defaultDialogueButton,
    },
  },
}

export const informerFields = {
  informerInfo: { ...defaultInformerInfo },
  informerRedirect: { ...defaultInformerRedirect },
}
